import Vue from 'vue'

function getImageUrl(image) {
  if (!image) return ''
  if (typeof image === 'string') return image
  if (typeof image.url === 'function') return image.url()
  if (image._url) return image._url
  return ''
}

Vue.mixin({
  methods: {
    $imgUrl: getImageUrl
  }
})
